module.exports = __webpack_public_path__ + "zilky-v-obliceji_4_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/zilky-v-obliceji_4_after.jpg
// module id = 999
// module chunks = 0